import { isUndefined, sortBy } from 'lodash';

import { type Account, type ClipDiscussionResponse, type Discussion } from '@air/api/types';
import { formatInitials } from '@air/utilities';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';
import { ASSET_MODAL_DISCUSSION_FILTERS } from '~/components/AssetModal/shared/context/DiscussionsPanelContext/discussionsPanelContextTypes';

export type TimestampMarkers = {
  discussion: ClipDiscussionResponse;
  timestamp: number;
  endTimestamp?: number;
  discussionId: Discussion['id'];
  userAvatar?: string;
  initials: string;
  userId: Account['id'];
}[];

export const getTimestampMarkers = ({
  data,
  currentVersion,
  filter,
}: {
  data: ClipDiscussion[];
  currentVersion: number;
  filter: ASSET_MODAL_DISCUSSION_FILTERS;
}) => {
  /** for consistent marker overlap */
  const markersData = sortBy(data, ['timestamp']);

  return markersData.reduce<TimestampMarkers>((acc, curr) => {
    if (!isUndefined(curr.timestamp) && curr.assetVersion === currentVersion) {
      const account = curr.comments.data[0].account;

      if (
        filter === ASSET_MODAL_DISCUSSION_FILTERS.ALL ||
        (filter === ASSET_MODAL_DISCUSSION_FILTERS.OPENED && !curr.resolved) ||
        (filter === ASSET_MODAL_DISCUSSION_FILTERS.RESOLVED && curr.resolved)
      ) {
        acc.push({
          discussion: curr,
          timestamp: curr.timestamp,
          endTimestamp: curr.endTimestamp,
          discussionId: curr.id,
          userAvatar: account.avatar || '',
          initials: formatInitials(account.firstName, account.lastName),
          userId: account.id,
        });
      }
    }

    return acc;
  }, []);
};
